module.exports = __webpack_public_path__ + "img/img08.06b68c0c.png";